import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import SweetAlert from "sweetalert2"
import { Box, Typography } from '@mui/material';
import Swal from 'sweetalert2';
import formatDate from '../../../../Functions/Traitement/fomatDate' //'../../../function/FormDate';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate'
import DataPeriod1 from "../../../../Functions/Traitement/DataPeriodAuto"
import Data from '../../../../Data/Data.json'
import Table, { ColumnsType } from 'antd/es/table';
import { Spin } from 'antd';
import { Crypter } from '../../../../Functions/Security/Crypter';
import Utilisateur from '../../../../Models/Utilisateur';
import DataType from "../../../../Functions/Traitement/DataPeriodAuto";
import InputForm from "../../../InputT";
import RadioBox from "../../../Radiox";
import DataSelect from '../../../../Types/DataSelect'
import SelectOption from "../../../SelectOption";



const VisualAutor = () => {

    // USER SESSION
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))

    //  declaration des usestates
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [StartForm, SetStartForm] = useState(true);
    const [, forceUpdate] = useState({});
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(true)
    const [modifActve, setModifActve] = useState(true)
    const [enregActve, setEnregActve] = useState(true)
    const [supActive, setSupActive] = useState(true)
    const [impActive, setImpActive] = useState(true)
    const [actuActive, setActActive] = useState(true)
    const [annulActive, setAnnulActive] = useState(true)
    const [consult, setConsult] = useState(false)
    const [donnees, setData] = useState<DataPeriod1[]>([]);
    const [FormAct, setFormactve] = useState(false);
    const [StartSearchG, SeStartSearchG] = useState(false)


    //******************** New ****************************/

    const dataOption2: DataSelect[] = [
        { label: " Découvert Invalide ", value: "INVALIDE" },
        { label: " Découvert Valide ", value: "VALIDE" }
    ]

    // usestate pour la recherche 
    const [SearchR, SetSearchR] = useState<string>("");


    // DECLARATION DES COLONNES DU TABLEAU
    const columns: ColumnsType<DataType> = [
        {
            title: 'Numéro découvert',
            dataIndex: 'NUMCRD',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.NUMCRD)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.NUMCLI)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.NOMCLI)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.SERVGE)
                        .toLowerCase()
                        .includes(value.toLowerCase())
            }

        },
        {
            title: 'ID client',
            dataIndex: 'NUMCLI',
        },
        {
            title: 'Nom client',
            dataIndex: 'NOMCLI',
        },
        {
            title: 'Status',
            dataIndex: 'CDETAT',
        },
        {
            title: 'Nature découvert',
            dataIndex: 'NATCRD',
        },
        {
            title: 'Montant',
            dataIndex: 'MNTAUT',
        },
        {
            title: 'Date effet',
            dataIndex: 'DATEFF',
        },
        {
            title: 'Date fin',
            dataIndex: 'DATEFIN',
        },
        {
            title: 'Numéro compte',
            dataIndex: 'CPTAUT',
        }

    ];


    // Handle pour la selection des element dans le tableau
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);



    // function pour la selection du tab
    const onSelectChange = (newSelectedRowKeys: any) => {
        console.log('selectedRowKeys changed: ', donnees[newSelectedRowKeys]);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    //******************** End New ***********************/



    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '6',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Visualisation découverts
                </span>
            ),
            children: <>
                <div className='tabItem' >
                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"} sx={{ p: 1 }} >
                          <legend> Visualisation des Découverts </legend>
                            <Box  className='border' style={{ display: 'flex'  }}  sx={{mb:1}} >

                                <Box className='border' style={{ textAlign: "center",width: '100%' }} >
                                  {/* <Form.Item style={{ width: '100%', marginBottom: -10, paddingLeft: 10 }} > */}
                                    < SelectOption disabled={false} Option={dataOption2}  width={0} label="Catégorie" Size={'100%'} name="ETAT" />
                                   
                                  {/* </Form.Item> */}
                                 </Box>
                               
                                  <Box   style={{ width: '100%',  marginBottom: -10,  paddingLeft: 10, paddingRight: 10}}  >

                                    <InputForm notRequired onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} label={'Recherche'} name="Element" type="string" />
                                  </Box>                       
                                
                                </Box>
                              
                             <Box className='border' fontStyle="inherit" >
                                    {/* <InputForm notRequired onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} label={'recherche'} name="Element" type="string" /> */}

                                <Spin spinning={loading}>
                                    <Table dataSource={donnees} style={{ textAlign: "center", width: '100%' }} columns={columns} size='small' pagination={false} scroll={{ y: 400, x: 400 }} />
                                </Spin>
                            </Box>
                               


                        </Box>
                    </div>
                </div >
            </>,
        }
    ]





    // function consultab
    function Consultab() {

        //etat de recharge
        //localStorage.setItem(Data.LocalVariable.reset, "1");

        // window.location.reload();
        // alert(form.getFieldValue('ETAT'))
        // alert(form.getFieldValue('TRIE'))
        // alert(form.getFieldValue('ELEMENT'))

        //alert(form.getFieldValue("ETAT"))

        if (form.getFieldValue("ETAT") == "VALIDE") {

            //alert(form.getFieldValue("ETAT") )

            let data1 = Crypter.encrypt('2');
            let data2 = Crypter.encrypt(Perss.codage)

            if (data1.length != 0 && data2.length != 0) {

                setLoading(true);
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ConsultTabPeriode,
                    headers: {
                        'CypherChoix': data1,
                        'CypherCodeage': data2,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };


                // MAPPING DANS LE TABLEAU
                let dat: DataPeriod1[] = [];

                axios.request(config)
                    .then((response) => {
                        setLoading(false);

                        //alert('one 1++' + response.data)
                        if (response.data) {


                            let datas1 = JSON.parse(Crypter.decrypt(response.data));
                            let datas = (datas1.Result);

                                

                            datas.map((val: any, key: any) => {
                                dat.push({
                                    key: key,
                                    NUMCRD: val.NUMCRD,
                                    NUMCLI: val.NUMCLI,
                                    NOMCLI: val.NOMCLI,
                                    SERVGE: val.SERVGE,
                                    NATCRD: val.NATCRD,
                                    MNTAUT: val.MNTAUT,
                                    DATEFF: val.DATEFF,
                                    DATEFIN: val.DATEFIN,
                                    CPTAUT: val.CPTAUT,
                                    CDETAT:val.CDETAT
                                }
                                )
                            })
                            setData(dat);

                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "ErrorW", text: error, icon: "error" })
                    });
            }


        } else if ((form.getFieldValue("ETAT") == "INVALIDE")) {

            //alert(form.getFieldValue("ETAT") )
            let data1 = Crypter.encrypt('3');
            let data2 = Crypter.encrypt(Perss.codage)

            if (data1.length != 0 && data2.length != 0) {

                setLoading(true);
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ConsultTabPeriode,
                    headers: {
                        'CypherChoix': data1,
                        'CypherCodeage': data2,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };


                // MAPPING DANS LE TABLEAU
                let dat: DataPeriod1[] = [];

                axios.request(config)
                    .then((response) => {
                        setLoading(false);

                        //alert('one 1++' + response.data)
                        if (response.data) {


                            let datas1 = JSON.parse(Crypter.decrypt(response.data));
                            let datas = (datas1.Result);



                            datas.map((val: any, key: any) => {
                                dat.push({
                                    key: key,
                                    NUMCRD: val.NUMCRD,
                                    NUMCLI: val.NUMCLI,
                                    NOMCLI: val.NOMCLI,
                                    SERVGE: val.SERVGE,
                                    NATCRD: val.NATCRD,
                                    MNTAUT: val.MNTAUT,
                                    DATEFF: val.DATEFF,
                                    DATEFIN: val.DATEFIN,
                                    CPTAUT: val.CPTAUT,
                                    CDETAT:val.CDETAT
                                }
                                )
                            })
                            setData(dat);

                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "ErrorW", text: error, icon: "error" })
                    });
            }

        } else {

            let data1 = Crypter.encrypt('5');
            let data2 = Crypter.encrypt(Perss.codage)

            if (data1.length != 0 && data2.length != 0) {

                setLoading(true);
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ConsultTabPeriode,
                    headers: {
                        'CypherChoix': data1,
                        'CypherCodeage': data2,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };


                // MAPPING DANS LE TABLEAU
                let dat: DataPeriod1[] = [];

                axios.request(config)
                    .then((response) => {
                        setLoading(false);

                        //alert('one 1++' + response.data)
                        if (response.data) {


                            let datas1 = JSON.parse(Crypter.decrypt(response.data));
                            let datas = (datas1.Result);



                            datas.map((val: any, key: any) => {
                                dat.push({
                                    key: key,
                                    NUMCRD: val.NUMCRD,
                                    NUMCLI: val.NUMCLI,
                                    NOMCLI: val.NOMCLI,
                                    SERVGE: val.SERVGE,
                                    NATCRD: val.NATCRD,
                                    MNTAUT: val.MNTAUT,
                                    DATEFF: val.DATEFF,
                                    DATEFIN: val.DATEFIN,
                                    CPTAUT: val.CPTAUT,
                                    CDETAT:val.CDETAT
                                }
                                )
                            })
                            setData(dat);

                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "ErrorW", text: error, icon: "error" })
                    });
            }

        }
    }

    // function Onfinish
    const onFinish = (values: any) => {

    };

    // control du forms 
    const onFinishFailed = (errorInfo: any) => {
        setLoading(true);
        setLoading(false);
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            SweetAlert.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> {window.location.pathname}</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>

                                <Button size='large' className='bt_add' disabled={false} onClick={() => { Consultab() }} type="ghost" htmlType="button" block  >
                                    Afficher
                                </Button>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button>

                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div >
                            <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                        </div>
                        <div>

                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}

export default VisualAutor;